import { useCadastroMedico } from 'hooks/useMedico';
import { useState } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';

const CAMPOS = [
  { label: 'Nome', campo: 'nome' },
  { label: 'CPF', campo: 'cpf' },
  { label: 'CELULAR', campo: 'celular' },
  { label: 'Especialidade', campo: 'especialidade' },
  { label: 'CRM', campo: 'crm' },
  { label: 'RQE', campo: 'rqe' },
  { label: 'Tipo', campo: 'tipo' },
];

export default function FormMedico({ codFunc, onProximoCampo, onCancelar, onSucesso, styles }) {
  const [form, setForm] = useState(Object.fromEntries(CAMPOS.map(({ campo }) => [campo, ''])));
  const { salvar, isSaving } = useCadastroMedico(codFunc);

  const setField = (campo) => (e) =>
    setForm((prev) => ({ ...prev, [campo]: e.target.value.toUpperCase() }));

  const handleSalvar = () => {
    salvar(form, () => onSucesso?.());
  };

  return (
    <div style={styles.panelRight}>
      <p
        style={{
          fontSize: '0.85rem',
          fontWeight: 700,
          color: '#0d9488',
          textAlign: 'center',
          marginBottom: 10,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
        }}
      >
        Novo Médico
      </p>

      {CAMPOS.map(({ label, campo }) => (
        <Form.Group key={campo} className="mb-2">
          <Form.Label style={{ fontSize: '0.78rem', marginBottom: 2, color: '#374151' }}>
            {label}
          </Form.Label>
          <Form.Control
            data-enter-nav="true"
            size="sm"
            value={form[campo]}
            onChange={setField(campo)}
            onKeyDown={(e) => e.key === 'Enter' && onProximoCampo(e)}
            onFocus={(e) => e.target.select()}
            style={{ ...styles.compact, textTransform: 'uppercase' }}
            autoComplete="off"
          />
        </Form.Group>
      ))}

      <div className="d-flex justify-content-center gap-2 mt-3">
        <Button
          variant="success"
          size="sm"
          onClick={handleSalvar}
          disabled={isSaving}
          style={{ minWidth: 80, background: '#0d9488', borderColor: '#0d9488' }}
        >
          {isSaving ? <Spinner animation="border" size="sm" /> : 'Gravar'}
        </Button>
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={onCancelar}
          disabled={isSaving}
          style={{ minWidth: 80 }}
        >
          Cancelar
        </Button>
      </div>
    </div>
  );
}
